<template>
  <div class="ai-provider-page">
    <el-card class="table-card">
      <div slot="header" class="card-header">
        <div class="card-header-left"><i class="el-icon-cpu"></i><span>AI配置</span>
          <el-divider direction="vertical"/><span class="header-sub">副AI（OpenAI兼容协议）配置</span></div>
        <div class="card-header-right">
          <el-radio-group v-model="purposeFilter" size="mini" @change="load">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button label="CLEAN">知识库清洗</el-radio-button>
            <el-radio-button label="GEN_COMBO">T3组合</el-radio-button>
            <el-radio-button label="GEN_PERWORD">T3单单词</el-radio-button>
            <el-radio-button label="GEN_PASSAGEFILL">T5短文填空</el-radio-button>
            <el-radio-button label="FALLBACK">实时降级</el-radio-button>
          </el-radio-group>
          <el-button type="primary" icon="el-icon-plus" @click="btnInsert">新增配置</el-button>
        </div>
      </div>
      <el-table :data="list" border stripe v-loading="tableLoading" element-loading-text="加载中...">
        <el-table-column type="index" label="序号" width="70" align="center"/>
        <el-table-column prop="providerName" label="名称" min-width="120"/>
        <el-table-column prop="apiUrl" label="接口地址" min-width="240" show-overflow-tooltip/>
        <el-table-column prop="model" label="模型" width="160"/>
        <el-table-column prop="purpose" label="用途" width="130" align="center">
          <template slot-scope="scope">
            <el-tag size="small" effect="plain" :type="purposeType(scope.row.purpose)">{{ purposeLabel(scope.row.purpose) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="enabled" label="启用" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.enabled===1?'success':'info'" size="small" effect="plain">{{ scope.row.enabled===1?'是':'否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="btnTest(scope.row)">连通测试</el-button>
            <el-button size="mini" type="text" @click="btnCopy(scope.row)">复制</el-button>
            <el-button size="mini" type="text" @click="btnEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="btnDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="dialogVisible" width="640px">
      <el-form :model="formData" ref="formRef" :rules="rules" label-width="110px">
        <el-form-item label="配置名称" prop="providerName">
          <el-input v-model="formData.providerName" placeholder="如：清洗副AI"/>
        </el-form-item>
        <el-form-item label="接口地址" prop="apiUrl">
          <el-input v-model="formData.apiUrl" placeholder="https://api.xxx.com/v1/chat/completions"/>
        </el-form-item>
        <el-form-item label="API Key" prop="apiKey">
          <el-input v-model="formData.apiKey" type="password" show-password placeholder="Bearer Token"/>
        </el-form-item>
        <el-form-item label="模型名" prop="model">
          <el-input v-model="formData.model" placeholder="如 deepseek-chat"/>
        </el-form-item>
        <el-form-item label="用途" prop="purpose">
          <el-select v-model="formData.purpose" placeholder="请选择">
            <el-option label="知识库清洗（T2诊断）" value="CLEAN"/>
            <el-option label="T3组合题型生成" value="GEN_COMBO"/>
            <el-option label="T3单单词题型生成" value="GEN_PERWORD"/>
            <el-option label="T5短文填空生成（独立任务）" value="GEN_PASSAGEFILL"/>
            <el-option label="实时降级" value="FALLBACK"/>
          </el-select>
          <div class="purpose-tip">CLEAN 同时作为 T3 未配置专用 AI 时的默认回落配置；各场景用途对应不同定时任务，可复制同一底层 AI 分配到不同场景实现分而治之</div>
        </el-form-item>
        <el-form-item label="温度">
          <el-input-number v-model="formData.temperature" :precision="2" :step="0.1" :min="0" :max="1"/>
        </el-form-item>
        <el-form-item label="超时(秒)">
          <el-input-number v-model="formData.timeoutSec" :min="1" :step="5" :max="300"/>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch v-model="formData.enabled" :active-value="1" :inactive-value="0"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="复制AI为其他场景" :visible.sync="copyVisible" width="560px">
      <el-form :model="copyForm" ref="copyRef" :rules="copyRules" label-width="110px">
        <el-form-item label="源配置">
          <el-input :value="copyForm.sourceName" disabled/>
        </el-form-item>
        <el-form-item label="新场景用途" prop="newPurpose">
          <el-select v-model="copyForm.newPurpose" placeholder="请选择目标场景">
            <el-option label="知识库清洗（T2诊断）" value="CLEAN"/>
            <el-option label="T3组合题型生成" value="GEN_COMBO"/>
            <el-option label="T3单单词题型生成" value="GEN_PERWORD"/>
            <el-option label="T5短文填空生成（独立任务）" value="GEN_PASSAGEFILL"/>
            <el-option label="实时降级" value="FALLBACK"/>
          </el-select>
          <div class="purpose-tip">复制后沿用源配置的接口地址/密钥/模型，仅场景(purpose)不同；新配置默认禁用，请确认后手动启用</div>
        </el-form-item>
        <el-form-item label="新配置名称">
          <el-input v-model="copyForm.newName" placeholder="留空则自动命名（源名称+副本）"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="copyVisible=false">取消</el-button>
        <el-button type="primary" @click="submitCopy" :loading="copyLoading">确定复制</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  reqAiProviderList, reqAiProviderDetail, reqAiProviderInsert,
  reqAiProviderUpdate, reqAiProviderDelete, reqAiProviderTest, reqAiProviderCopy
} from '@/api/education/aiProvider'

export default {
  name: 'AiProviderConfig',
  data() {
    return {
      list: [],
      purposeFilter: '',
      tableLoading: false,
      dialogVisible: false,
      dialogTitle: '',
      submitLoading: false,
      formData: this.emptyForm(),
      copyVisible: false,
      copyLoading: false,
      copyForm: { sourceId: null, sourceName: '', newPurpose: 'GEN_PASSAGEFILL', newName: '' },
      copyRules: {
        newPurpose: [{ required: true, message: '请选择新场景用途', trigger: 'change' }]
      },
      rules: {
        providerName: [{ required: true, message: '请输入配置名称', trigger: 'blur' }],
        apiUrl: [{ required: true, message: '请输入接口地址', trigger: 'blur' }],
        apiKey: [{ required: true, message: '请输入API Key', trigger: 'blur' }],
        model: [{ required: true, message: '请输入模型名', trigger: 'blur' }],
        purpose: [{ required: true, message: '请选择用途', trigger: 'change' }]
      }
    }
  },
  created() { this.load() },
  methods: {
    emptyForm() {
      return { id: null, providerName: '', apiUrl: '', apiKey: '', model: '', purpose: 'CLEAN', temperature: 0.3, timeoutSec: 120, timeout: 120000, enabled: 1 }
    },
    async load() {
      this.tableLoading = true
      try {
        this.list = await reqAiProviderList(this.purposeFilter)
      } catch (e) { this.$message.error('加载失败') }
      finally { this.tableLoading = false }
    },
    purposeLabel(p) {
      return ({ CLEAN: '知识库清洗', GEN_COMBO: 'T3组合生成', GEN_PERWORD: 'T3单单词生成', GEN_PASSAGEFILL: 'T5短文填空', FALLBACK: '实时降级' })[p] || p || '-'
    },
    purposeType(p) {
      return ({ CLEAN: 'primary', GEN_COMBO: 'success', GEN_PERWORD: 'warning', GEN_PASSAGEFILL: 'danger', FALLBACK: 'info' })[p] || 'info'
    },
    btnInsert() { this.formData = this.emptyForm(); this.dialogTitle = '新增AI配置'; this.dialogVisible = true },
    async btnEdit(row) {
      try {
        const data = await reqAiProviderDetail(row.id)
        this.formData = { ...this.emptyForm(), ...data }
        // 后端 timeout 单位为毫秒，界面以秒展示
        this.formData.timeoutSec = data.timeout != null ? Math.round(data.timeout / 1000) : 120
        this.dialogTitle = '编辑AI配置'
        this.dialogVisible = true
      } catch (e) { this.$message.error('获取详情失败') }
    },
    async btnDelete(row) {
      try {
        await this.$confirm('确认删除该配置？', '提示', { type: 'warning' })
        await reqAiProviderDelete(row.id)
        this.$message.success('已删除')
        this.load()
      } catch (e) { if (e !== 'cancel') this.$message.error('删除失败') }
    },
    btnCopy(row) {
      this.copyForm = { sourceId: row.id, sourceName: row.providerName, newPurpose: 'GEN_PASSAGEFILL', newName: '' }
      this.copyVisible = true
    },
    submitCopy() {
      this.$refs.copyRef.validate(async (valid) => {
        if (!valid) return
        this.copyLoading = true
        try {
          const params = {
            sourceId: this.copyForm.sourceId,
            newPurpose: this.copyForm.newPurpose,
            newName: this.copyForm.newName || undefined
          }
          await reqAiProviderCopy(params)
          this.$message.success('复制成功，新配置默认禁用，请确认后启用')
          this.copyVisible = false
          this.load()
        } catch (e) { this.$message.error('复制失败') }
        finally { this.copyLoading = false }
      })
    },
    async btnTest(row) {
      try {
        const ok = await reqAiProviderTest(row.id)
        this.$message.success(ok ? '连通性正常' : '连通失败')
      } catch (e) { this.$message.error('测试失败') }
    },
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        try {
          // 界面以秒录入，转回毫秒提交后端
          const payload = { ...this.formData, timeout: (this.formData.timeoutSec || 0) * 1000 }
          if (this.formData.id) await reqAiProviderUpdate(payload)
          else await reqAiProviderInsert(payload)
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.load()
        } catch (e) { this.$message.error('保存失败') }
        finally { this.submitLoading = false }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-provider-page { padding: 16px; }
.card-header { display: flex; justify-content: space-between; align-items: center; }
.header-sub { color: #909399; font-size: 12px; }
.card-header-right { display: flex; align-items: center; gap: 12px; }
.purpose-tip { font-size: 12px; color: #909399; margin-top: 4px; line-height: 1.4; }
</style>
